import React, { useEffect, useState } from 'react';
import { LazyLoadImage } from 'react-lazy-load-image-component';
import Lightbox from 'react-image-lightbox';
import { useTheme } from '@mui/material/styles';
import useMediaQuery from '@mui/material/useMediaQuery';
import Box from '@mui/material/Box';
import ImageList from '@mui/material/ImageList';
import ImageListItem from '@mui/material/ImageListItem';
import Button from '@mui/material/Button';

import Grid from '@mui/material/Grid';
import Main from 'layouts/Main';


import { Typography } from '@mui/material';
import Container from 'components/Container';
import PreprimarySidebar2026 from '../PreprimarySidebar2026';
import Presidebar2026 from '../Presidebar2026/Presidebar2026';


const PictureTalk2026= () => {
  const theme = useTheme();
  const [currentImage, setCurrentImage] = useState(0);
  const [viewerIsOpen, setViewerIsOpen] = useState(false);

  const openLightbox = (index) => {
    setCurrentImage(index);
    setViewerIsOpen(true);
  };

  const closeLightbox = () => {
    setCurrentImage(0);
    setViewerIsOpen(false);
  };

  const isMd = useMediaQuery(theme.breakpoints.up('md'), {
    defaultMatches: true,
  });

  const [config, setConfig] = useState({ base_image_url_2026: '' });
  useEffect(() => {
    fetch('/config.json')  // For Gatsby, this will resolve to /config.json from the static folder
      .then(response => response.json())
      .then(data => setConfig(data))
      .catch(error => console.error('Error fetching config:', error));
  }, []);
  
  const p1 = `${config.base_image_url_2026}/home/events-activities/club/EcoClub/PictureTalk/1.webp`;
  const p2 = `${config.base_image_url_2026}/home/events-activities/club/EcoClub/PictureTalk/2.webp`;
  const p3 = `${config.base_image_url_2026}/home/events-activities/club/EcoClub/PictureTalk/3.webp`;
  const p4 = `${config.base_image_url_2026}/home/events-activities/club/EcoClub/PictureTalk/4.webp`;
  const p5 = `${config.base_image_url_2026}/home/events-activities/club/EcoClub/PictureTalk/5.webp`;
  const p6 = `${config.base_image_url_2026}/home/events-activities/club/EcoClub/PictureTalk/6.webp`;

  const photos = [
    {
    src: p1,
    source: p1,
    rows: 1,
    cols: 1,
},
{
    src: p2,
    source: p2,
    rows: 1,
    cols: 1,
},
{
    src: p3,
    source: p3,
    rows: 1,
    cols: 1,
},
{
    src: p4,
    source: p4,
    rows: 1,
    cols: 1,
},
{
    src: p5,
    source: p5,
    rows: 1,
    cols: 1,
},
{
    src: p6,
    source: p6,
    rows: 1,
    cols: 1,
},




  ];

  return (
    <Main>
   
<Container>

  <Grid container spacing={4}>
            <Grid item xs={12} md={8}>
    <Box>
        
      <Box >
      <Typography variant='h4' align='center' >
 Topic: Picture Talk
        </Typography>
        <Typography
        fontSize = "x-small"
        ><br/><br/>
    Classes:  KINDERGARTEN     Date: 24 July 2026
        </Typography>
        <Typography
          variant={'h6'}
          color={'primary'}
          align={'center'}
          fontWeight={'normal'}
        ><br/>
 Picture Talk – Little Voices, Big Ideas
<br></br>
        </Typography>


        <Typography variant={'subtitle1'} align={'justify'}>
The <u>Pre-Primary </u>Department of National Public School,<u> Yeshwanthpur,</u> conducted<strong> Picture Talk – Little Voices, 
Big Ideas on 24 July 2026. </strong> The event provided a wonderful platform for our young learners to express themselves 
confidently through colourful pictures, creative storytelling, and meaningful conversations.
      <br></br>
Students from <u>Pre-K,</u> KG I, and KG II enthusiastically presented a variety of age-appropriate themes, including rhymes, family, healthy habits, festivals, <u> colours,</u> animals, careers,
 transport, nature, inventions, science, national symbols, monuments, seasons, and friendship. Through their imaginative presentations,
 they shared thoughtful ideas, identified objects, conveyed important values, and demonstrated excellent observation and communication skills.
 <br></br>

The activity fostered confidence, creativity, vocabulary development, critical thinking, and self-expression.
 Every child participated with enthusiasm, making the event a joyful celebration of learning, imagination, and the power of young voices.
<br></br>


        </Typography>
      </Box>
      {/* <Typography
          variant={'h6'}
          color={'primary'}
          align={'center'}
          fontWeight={'normal'}
        ><br/>
"Crafted by tiny hands, inspired by Mother Earth"

<br/>
        </Typography> */}

      <Box>
        <ImageList
          variant="quilted"
          cols={2}
          rowHeight={isMd ? 300 : 200}
          gap={isMd ? 16 : 4}
        >
          {photos.map((item, i) => (
            <ImageListItem key={i} cols={item.cols} rows={item.rows}>
              <LazyLoadImage
                height={'100%'}
                width={'100%'}
                src={item.src}
                alt="..."
                effect="blur"
                onClick={() => openLightbox(i)}
                style={{
                  objectFit: 'cover',
                  filter:
                    theme.palette.mode === 'dark' ? 'brightness(0.7)' : 'none',
                  cursor: 'poiner',
                  borderRadius: 8,
                }}
              />
            </ImageListItem>
          ))}
        </ImageList>
      </Box>
      {viewerIsOpen && (
        <Lightbox
          mainSrc={photos[currentImage].src}
          nextSrc={photos[(currentImage + 1) % photos.length].src}
          prevSrc={
            photos[(currentImage + photos.length - 1) % photos.length].src
          }
          onCloseRequest={() => closeLightbox()}
          onMovePrevRequest={() =>
            setCurrentImage((currentImage + photos.length - 1) % photos.length)
          }
          onMoveNextRequest={() =>
            setCurrentImage((currentImage + 1) % photos.length)
          }
          reactModalStyle={{ overlay: { zIndex: 1500 } }}
        />
      )}
    </Box>
    </Grid>

    <Grid item xs={12} md={4}>
             
             <Box marginBottom={4}>
               <PreprimarySidebar2026 />
             </Box>
             <Box marginBottom={4}>
               <Presidebar2026 />
             </Box>


    </Grid>
    </Grid> 
    </Container>
    </Main>
   
   
  );
};

export default PictureTalk2026;